<template>
  <div class="home container-fluid">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-xs-12 mt-md title text-center">
          X-Wing vs Tie-Fighter
        </div>
        <div class="col-lg-12 col-xs-12 mt-md subtitle text-center">
          Fan-Remake
        </div>
      </div>
      <div class="row mt-xl">
        <div class="col-lg-12 col-md-12 col-xs-12 text-center">
          <button class="btn launch-btn" v-ripple @click="launchGame()">Launch Tech Demo</button>
          <div class="mt-sm"><small>Controls: WASD (QE), Arrow Keys, Space</small></div>
          <div class="mt-sm"><small>Loading time could be high. Assets/Models aren't optimized; Hitbox of star destroyer is too large; Everything is work in progress :)</small></div>
        </div>
      </div>
      <div class="row mt-xl" v-if="1==2">
        <div class="col-lg-6 col-md-6 col-xs-12">
          Support me via Patreon:<br>
          <div class="mt-md">
            <a href="https://www.patreon.com/bePatron?u=8344505" data-patreon-widget-type="become-patron-button" target="_blank">Become a Patron!</a>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-xs-12">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  components: {
  },
  methods: {
    launchGame() {
      setTimeout(() => {
        window.location = "/game/index.html"
      },1000)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .home {
    color: rgb(243,243,243)
    font-family: 'Righteous', cursive;
  }
  .title {
    font-family: 'Righteous', cursive;
    font-size:50px
  }
  .subtitle {
    font-size:30px
  }
  .btn {
    cursor:pointer
  }
  .launch-btn {
    font-family: 'Righteous', cursive;
    transition: all ease 0.4s
    padding-left:20px
    padding-right:20px
    padding-top:12px
    background-color:transparent
    padding-bottom:12px
    font-size:20px
    color: rgba(26,149,236,1)
    border: 1px solid rgba(26,149,236,1)
    &:hover {
      background-color: rgba(26,149,236,0.7)
      color: white
    }
  }
</style>
